import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Header from './common/Header';
import Footer from './common/Footer';
import Router from './Router';
import SiteMotion from './common/SiteMotion';
import { I18nProvider } from './i18n/I18nContext';
import translations from './i18n/translations';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const header = ReactDOM.createRoot(document.getElementById('header'));
const footer = ReactDOM.createRoot(document.getElementById('footer'));

function onRouteChanged(route) {
  header.render(
    <React.StrictMode>
      <I18nProvider path={window.location.pathname} messages={translations}>
        <Header route={route} />
      </I18nProvider>
    </React.StrictMode>
  );

  footer.render(
    <React.StrictMode>
      <I18nProvider path={window.location.pathname} messages={translations}>
        <Footer route={route} />
      </I18nProvider>
    </React.StrictMode>
  );
};

root.render(
  <React.StrictMode>
    <I18nProvider path={window.location.pathname} messages={translations}>
      <SiteMotion>
        <Router path={window.location.pathname} onRouteChanged={onRouteChanged} />
      </SiteMotion>
    </I18nProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
